import { newStorage } from './storage';

const signupPageTableStorage = newStorage('TABLE_SIGNUP_PAGE');

export default signupPageTableStorage;
